<template>
  <b-list-group class="listGroup thin-scroll">
    
    <b-list-group-item class="listGroupItem" v-for="notification in notifications" v-bind:key="notification.id">
      <p class="m-0 overflow-hidden" style="line-height:1.7">
        {{notification.message}}
        &nbsp;&nbsp;
        <b-button @click="doAction(link)" v-for="link in notification.links" v-bind:key="link.id" size="xs" :variant="link.colour=='green'?'success':'danger'" class="mr-1 float-right">{{link.name}}</b-button>
        <time class="help-block m-0">
          {{ dateFormat(notification.created_at) }}
        </time>
      </p>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import common from '@/assets/js/common.js';
import moment from 'moment';

export default {
  name: 'NewNotificationsList',
  mixins: [common],
  props: {
    notifications: {
      type: Array, 
      default() {
          return []
      }
    }
  },
  methods: {
    doAction(link) {
      if(link.action == 'download')
        window.open(this.get_baseURL() + link.path + '&api_token=' + window.localStorage.getItem('auth_token'), '_blank').focus();
      else if(link.action == 'api') {
        if(confirm('Are you sure to '+link.name.toLowerCase())){
          this.$toasted.success("Your request submitted successfully!",{duration:1000});
          this.call_axios(link.path, 'post');
        }
      }
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD HH:MM')
    }
  }
};
</script>

<style src="./ListGroup.scss" lang="scss" />
